import { createAppSlice } from '@store/createAppSlice';
import { activateProducts } from 'common/api';
import type { SoftwareProduct } from 'modules/softwareProducts/useSoftwareProducts';

export type SimpleProduct = Pick<
  SoftwareProduct,
  'type' | 'agreementDetailId' | 'commercialProductId' | 'status' | 'name' | 'freezeDetails'
> & { image?: string };

const initialState = {
  productsSelectedForActivation: [] as SimpleProduct[],
};

const activationSlice = createAppSlice({
  name: 'activate',
  initialState,
  reducers: (create) => ({
    activateProducts: create.asyncThunk((activationRequest: Parameters<typeof activateProducts>[0]) =>
      activateProducts(activationRequest),
    ),
    addProductToActivationList: create.reducer<SimpleProduct>((state, action) => {
      state.productsSelectedForActivation.push(action.payload);
    }),
    removeProductFromActivationList: create.reducer<SimpleProduct>((state, action) => {
      state.productsSelectedForActivation = state.productsSelectedForActivation.filter(
        (x) => x.agreementDetailId !== action.payload.agreementDetailId,
      );
    }),
  }),
  selectors: {
    getProductsSelectedForActivation: (state) => state.productsSelectedForActivation || [],
    isSelectedForActivation: (state, product: SimpleProduct) =>
      (state.productsSelectedForActivation || []).some((x) => x.agreementDetailId === product.agreementDetailId),
  },
});

export const activationActions = activationSlice.actions;

// Business units - there customers have access to later activation actions
// Could we configure this in the cms
// also we could use customer type instead, it's under discussion
// const fiberPartnerBusinessUnitIds = [
//   84, //RealNett
//   4, //Obos
//   82, //Numedal
//   85, //Nextgentel
//   62, //Nettstar
//   23, //Luostejok
//   22, //InfraNord
//   2, //HomeNet
//   42, //GP
// ];

export const activationSelectors = activationSlice.selectors;

export default activationSlice.reducer;
